module.exports = __webpack_public_path__ + "3255c672f2ce31c461784e26fd820dd8.svg";